import React from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import moment from 'moment';

// path = /fjs/:id
// Component purpose is to display individual food journal stories
const FJSDetails = (props) => {
  const { fjStory, auth } = props;
  if (!auth.uid) return <Redirect to ='/signin' />

  if (fjStory) {
    return (
      <>
        <div className=''>
          <div className=''>{fjStory.title}</div>
          <div className=''>{fjStory.content}</div>
          <div className=''>{fjStory.userName}</div>
          <div className=''>{moment(fjStory.createdAt.toDate()).calendar()}</div>
        </div>
      </>
    )
  } else {
    return (
      <p>Loading project</p>
    )
  }

}
// ownProps is the props of the component 
const mapStateToProps = (state, ownProps) => {
  const id = ownProps.match.params.id;
  const fjStories = state.firestore.data.fjStories;
  const fjStory = fjStories ? fjStories[id] : null;
  return {
    fjStory: fjStory,
    auth: state.firebase.auth
  }
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    { collection: 'fjStories' }
  ])
)(FJSDetails);